import './navigation.scss';

angular
.module('app.views')
.controller('NavigationController', function($rootScope, $scope, $location, $window, User, Account, AuthService) {
    $scope.linkClass = function(path, isExact) {
        const actual = $location.path();
        if ((path === actual) || (!isExact && (actual.indexOf(path) === 0))) {
            return 'active';
        } else {
            return '';
        }
    };

    const reloadMe = () => {
        $scope.me = User.me();
        $rootScope.me = $scope.me;
        $scope.me.$promise.then(() => {
            console.dir($scope.me);
            if (!$scope.me.isBoxcastAdmin()) {
                $window.alert("Whoops -- looks like you're not a BoxCast admin...");
                AuthService.logOut();
            }
        })
    };
    reloadMe();

    $scope.$on('impersonate_initiated', reloadMe);

    $scope.stopImpersonating = () => {
        Account.stopImpersonating().$promise.then(reloadMe);
    };

    $scope.logOut = function() {
        AuthService.logOut();
    };
});



// WEBPACK FOOTER //
// ./views/navigation/navigation_controller.js